import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Alert from 'react-bootstrap/Alert';
import { REVREX_APP_BASE_URL, URLS } from '../../resources/constants'
import { getUser } from '../../store/user/selectors'
import { getBankAccountMatchSettings, getOpeningBalanceExistsSettings, getAccountSettings, getThirdPartyStepsCompleted, getMonthClosedBetweenDepositAndSalesMismatch } from '../../store/settings/selectors'
// import { getFirstLoginStatus } from '../../store/settings/selectors'
import { useSettingsApi } from '../../resources/hooks/api/useSettingsApiHook';
import ChartAccountModal from '../../components/Modal/ChartOfAccount/ChartAccountModal'
//import { useUserDataApi } from '../../resources/hooks/api/userDataApiHook'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

import RevrexSyncGLAcc from '../../components/Modal/RevrexSyncGLAcc/RevrexSyncGLAcc';
import revenueReconciliationIcon from '../../assets/images/revenue-reconciliation-icon-w.svg';
import expenseClassificationIcon from '../../assets/images/expense-classification-icon-w.svg';
import exitStrategyIcon from '../../assets/images/exit-strategy-icon-w.svg';
import reportIcon from '../../assets/images/report-icon-w.svg';

import { getBranch } from '../../store/user/selectors'
import SAlert from 'components/SAlert';
import toast from 'react-hot-toast';


interface Props {

}

const Dashboard: React.FC<Props> = () => {
    //   const _records = useSelector(getTableDataRecords)
    //   const _users = useSelector(getUser)
    const _getBankAccountMatchSettings = useSelector(getBankAccountMatchSettings);
    // const _getOpeningBalanceExistsSettings = useSelector(getOpeningBalanceExistsSettings);
    const _getAccountSettings = useSelector(getAccountSettings);
    const _getThirdPartyStepsCompleted = useSelector(getThirdPartyStepsCompleted);
    const userData = useSelector(getUser)
    const _getMonthClosedBetweenDepositAndSalesMismatch = useSelector(getMonthClosedBetweenDepositAndSalesMismatch);
    const { t } = useTranslation("scenes.dashboard");
    const navigate = useNavigate();

    // const { userAllowance, userStepStatus } = useUserApi();
    const { fetchAccountSettingsData, upgradeToLatestGL } = useSettingsApi();
    // const { dashboardRaioData } = useReportApi();
    // const _userSteps = useSelector(getFirstLoginStatus);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showCOAModal, setShowCOAModal] = useState<boolean>(false)
    const [createNewAccount, setCreateNewAccount] = useState<boolean>(false);
    // const [confirmationToLatest, setConfirmationToLatest] = useState<boolean>(false);
    // const [dashboardRatio, setDashboardRatio] = useState<any | null>(null);
    const [modalSyncGl, setModalSyncGl] = useState<any>({
        syncBankAcc: false,
        syncSalesAcc: false
    });
    const [showQBOAlert, setShowQBOAlert] = useState<boolean>(false);
    const [showPosMismatchClosedMonthDepositSalesAlert, setShowPosMismatchClosedMonthDepositSalesAlert] = useState<boolean>(false);

    const branchData = useSelector(getBranch)

    useEffect(() => {
        // fetchAccMapping();
        getSettingsData();
        // fetchUserSteps();
        // getDashboardRatioData();
    }, [])

    useEffect(() => {
            if ([1, 2].includes(_getThirdPartyStepsCompleted)) {
                navigate(URLS.THIRD_PARTY);
            }

            setShowQBOAlert(_getThirdPartyStepsCompleted >= 3 && _getAccountSettings.bank_account_count == 0);

            console.log('1. _getMonthClosedBetweenDepositAndSalesMismatch: ', _getMonthClosedBetweenDepositAndSalesMismatch)
            if (_getMonthClosedBetweenDepositAndSalesMismatch && _getAccountSettings.is_beginning_balance_exists == 1 && _getAccountSettings.is_coa_modified == 1) {
                console.log('2. _getMonthClosedBetweenDepositAndSalesMismatch: ', _getMonthClosedBetweenDepositAndSalesMismatch)
                setShowPosMismatchClosedMonthDepositSalesAlert(true);
            } else {
                console.log('3. _getMonthClosedBetweenDepositAndSalesMismatch: ', _getMonthClosedBetweenDepositAndSalesMismatch)
                setShowPosMismatchClosedMonthDepositSalesAlert(false);
            }
    }, [_getThirdPartyStepsCompleted, _getAccountSettings, _getMonthClosedBetweenDepositAndSalesMismatch])

    const getSettingsData = () => {
        fetchAccountSettingsData({ branch_id: +branchData['id'] }, (msg: string, resp: any) => {
            
        }, (msg: string, resp: any) => {
            
        })
    }

    const upsertCOA = (addNew: boolean) => {
        setCreateNewAccount(addNew);
        setShowCOAModal(true);
    }

    const hideCOAModal = () => {
        setShowCOAModal(false);
    }

    const updateSyncGlModal = (params: any) => {
        setModalSyncGl((prevState: any) => {
            return {
                ...prevState,
                ...params
            }
        })
    }

    const confirmUpdationToLatest = () => {
        setIsLoading(true);
        upgradeToLatestGL({ branch_id: +branchData['id'] }, (msg: string, resp: any) => {
            setIsLoading(false);
            toast.success(resp?.data?.message || msg);
        }, (msg: string, resp: any) => {
            setIsLoading(false);
            toast.error(resp?.data?.message || msg);
        })
    }

    const closeSyncModal = () => {
        setModalSyncGl({
            syncBankAcc: false,
            syncSalesAcc: false
        })
        getSettingsData();
    }

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title py-4">
                    <div className="row align-items-center">
                        <div className="col-sm-12">
                            <h1 className="h3 font-weight-700  mb-0">{t('dashboard.title')}</h1>
                        </div>
                    </div>
                </div>

                <div className="filter-btn">
                    <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                        <div className="loader"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {
                            !_getBankAccountMatchSettings && (
                                <Alert variant="danger">
                                    <span>
                                        {t('dashboard.acc_not_sync')} <strong>{t('dashboard.acc_not_sync_bold')}</strong>.
                                    </span>&nbsp;&nbsp;
                                    <button className='btn btn-sm btn-primary' onClick={() => updateSyncGlModal({ syncBankAcc: true })}>{t('dashboard.acc_not_sync_btn')}</button>
                                </Alert>
                            ) || <></>
                        }
                        {/* {
                            _getOpeningBalanceExistsSettings && (
                                <Alert variant="danger">
                                    <span>
                                        {t('dashboard.upgrade.statement_1')} <strong>{t('dashboard.upgrade_bold')}</strong> {t('dashboard.upgrade.statement_2')}
                                    </span>&nbsp;&nbsp;
                                    <button className='btn btn-sm btn-primary' onClick={() => setConfirmationToLatest(true)}>{t('dashboard.upgrade_btn')}</button>
                                </Alert>
                            ) || <></>
                        } */}
                        {/* {
                            !_getMappedAcc.sales_activity_match && (
                                <Alert variant="danger">
                                    <span>
                                        Any of the POS(s) from your RevRex account is not associated with related GL account. Please go back to your account and assign the associated GL account <strong>before going to Sales GL Classification</strong>.
                                    </span>&nbsp;&nbsp;
                                    <button className='btn btn-sm btn-primary' onClick={() => updateSyncGlModal({ syncSalesAcc: true })}>Sync With RevRex</button>
                                </Alert>
                            ) || <></>
                        } */}
                        {/* {
                            !_getMappedAcc.sales_activity_match && (
                                <Alert variant="danger">
                                    <span>
                                        Any of the POS(s) from your RevRex account is not associated with related GL account. Please go back to your account and assign the associated GL account <strong>before going to Sales GL Classification</strong>.
                                    </span>&nbsp;&nbsp;
                                    <button className='btn btn-sm btn-primary' onClick={() => updateSyncGlModal({ syncSalesAcc: true })}>Sync With RevRex</button>
                                </Alert>
                            ) || <></>
                        } */}
                    </div>
                </div>
                {
                    (_getAccountSettings.is_beginning_balance_exists == 1 && _getAccountSettings.is_coa_modified == 1) && _getAccountSettings.transaction_activity_status >= 3 ? (
                        <div className="dashboard-wrap">
                            <div className="row align-items-stretch g-3">
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample1">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        <img src={revenueReconciliationIcon} alt="" /> {t('dashboard.classification')}
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample1">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            <li>
                                                                <Link to={URLS.REVENUE_GL_CLASSIFICATION_STATUS}>{t('dashboard.classification.deposit')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.EXPENSE_GL_CLASSIFICATION_STATUS}>{t('dashboard.classification.expense')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.SALES_GL_CLASSIFICATION_STATUS}>{t('dashboard.classification.revenue')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.CREDIT_CARD_GL_CLASSIFICATION_STATUS}>{t('dashboard.classification.credit_card')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.BANK_RECONCILE}>{t('dashboard.classification.reconcilation')}</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample2">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingTwo">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                                        <img src={expenseClassificationIcon} alt="" /> {t('dashboard.maintainance')}
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample2">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            <li>
                                                                <Link to={URLS.CHARTACCOUNT}>{t('dashboard.maintainance.manage_chart_of_accounts')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={'#'} onClick={() => upsertCOA(false)}>{t('dashboard.maintainance.change_existing_account')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={'#'} onClick={() => upsertCOA(true)}>{t('dashboard.maintainance.add_new_account')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.VIEW_REGISTER}>{t('dashboard.maintainance.transaction_register')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.BUDGET}>{t('dashboard.maintainance.budget_entry')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.OPENNING_BALANCE}>{t('dashboard.maintainance.beginning_balance_entry')}</Link>
                                                            </li>
                                                            {/* {
                                                                _getMappedAcc?.sales_activity_count == 0 && (

                                                                    <li>
                                                                        <Link to={URLS.VIEW_REGISTER}>Transaction Register</Link>
                                                                    </li>

                                                                ) || <></>
                                                            }
                                                            <li>
                                                            {
                                                                _getMappedAcc?.sales_activity_count != 0 && (
                                                                    <Link to={URLS.VIEW_REGISTER}>Transaction Register</Link>

                                                                ) || <></>
                                                            }
                                                            </li> */}
                                                            {/* <li>
                                                        <Link to={URLS.SALES_GL_CLASSIFICATION}>Sales GL Classification</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={URLS.CREDIT_CARD_GL_CLASSIFICATION}>Credit GL Classification</Link>
                                                    </li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample3">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingThree">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                                        <img src={exitStrategyIcon} alt="" /> {t('dashboard.forms')}
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" className="accordion-collapse collapse show" aria-labelledby="headingThree" data-bs-parent="#accordionExample3">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            {/* <li>
                                                        <Link to="#">Data Export</Link>
                                                    </li> */}
                                                            <li>
                                                                <Link to={URLS.FOURTHREETHREEB}>{t('dashboard.forms.433_b')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.PERSONAL_INCOME_STATMENT}>{t('dashboard.forms.personal_income_statement')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.PERSONAL_BALANCE_SHEET}>{t('dashboard.forms.personal_balance_sheet')}</Link>
                                                            </li>
                                                            {/* <li>
                                                                <Link to="#">{t('dashboard.forms.five_year_forecast_entry')}</Link>
                                                            </li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample4">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingFour">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                                        <img src={reportIcon} alt="" /> {t('dashboard.reports')}
                                                    </button>
                                                </h2>
                                                <div id="collapseFour" className="accordion-collapse collapse show" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            <li>
                                                                <Link to={URLS.BANK_TRANSACTION}>{t('dashboard.reports.bank_transaction_history')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.SALES_TRANSACTION}>{t('dashboard.reports.sales_transaction_history')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.BALANCESHEET}>{t('dashboard.reports.balance_sheet')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link to={URLS.PROFITLOSS}>{t('dashboard.reports.statement_of_income')}</Link>
                                                            </li>
                                                            {/* <li>
                                                                <Link to={URLS.STATEMENT_OF_CASH_FLOW}>Statement of Cash Flow</Link>
                                                            </li> */}
                                                            <li>
                                                                <Link to={URLS.BUSINESS_RATIO}>{t('dashboard.reports.business_ratios')}</Link>
                                                            </li>
                                                            {/* <li>
                                                                <Link to={URLS.FOURTHREETHREEB}>433-B FORM</Link>
                                                            </li> */}
                                                            {/* <li>
                                                        <Link to="#">Custom Reports</Link>
                                                    </li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (_getAccountSettings.is_beginning_balance_exists == 1 && _getAccountSettings.is_coa_modified == 1 && (_getThirdPartyStepsCompleted == 0 || _getThirdPartyStepsCompleted > 2)) ? (
                        <div className="dashboard-wrap">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="steps-panel-wrapper">
                                        <ul className="steps-panel">
                                            <li className={`step-block ${_getAccountSettings.transaction_activity_status === 0 ? 'active' : 'completed'}`}>
                                                <div className='step-block-inner'>
                                                    <span><Link to={URLS.REVENUE_GL_CLASSIFICATION_STATUS} className='steps-panel-a'>3</Link></span>
                                                    <h4><Link to={URLS.REVENUE_GL_CLASSIFICATION_STATUS} className='steps-panel-a'>{t('dashboard.step_3.title')}</Link></h4>
                                                </div>

                                                {/* <Link to={URLS.REVENUE_GL_CLASSIFICATION_STATUS} className='steps-panel-a'>
                                                    <span>3</span>
                                                    <h4>Deposit Classification</h4>
                                                </Link> */}
                                            </li>
                                            <li className={`step-block ${_getAccountSettings.transaction_activity_status === 0 ? '' : _getAccountSettings.transaction_activity_status === 1 ? 'active' : _getAccountSettings.transaction_activity_status === 2 ? 'completed' : 'completed'}`}>
                                                <div className='step-block-inner'>
                                                    <span><Link to={_getAccountSettings.transaction_activity_status == 1 || _getAccountSettings.transaction_activity_status == 2 ? URLS.EXPENSE_GL_CLASSIFICATION_STATUS : 'javascript:void(0)'} className='steps-panel-a'>4</Link></span>
                                                    <h4><Link to={_getAccountSettings.transaction_activity_status == 1 || _getAccountSettings.transaction_activity_status == 2 ? URLS.EXPENSE_GL_CLASSIFICATION_STATUS : 'javascript:void(0)'} className='steps-panel-a'>{t('dashboard.step_4.title')}</Link></h4>
                                                </div>

                                                {/* <Link to={_getAccountSettings.transaction_activity_status == 1 || _getAccountSettings.transaction_activity_status == 2 ? URLS.EXPENSE_GL_CLASSIFICATION_STATUS : 'javascript:void(0)'} className='steps-panel-a'>
                                                    <span>4</span>
                                                    <h4>Expense Classification</h4>
                                                </Link> */}
                                            </li>
                                            <li className={`step-block ${_getAccountSettings.transaction_activity_status === 0 ? '' : _getAccountSettings.transaction_activity_status === 1 ? '' : _getAccountSettings.transaction_activity_status === 2 ? 'active' : _getAccountSettings.transaction_activity_status >= 3 ? 'completed' : 'completed'}`}>
                                                <div className='step-block-inner'>
                                                    <span><Link to={_getAccountSettings.transaction_activity_status == 2 ? URLS.SALES_GL_CLASSIFICATION_STATUS : 'javascript:void(0)'} className='steps-panel-a'>5</Link></span>
                                                    <h4><Link to={_getAccountSettings.transaction_activity_status == 2 ? URLS.SALES_GL_CLASSIFICATION_STATUS : 'javascript:void(0)'} className='steps-panel-a'>{t('dashboard.step_5.title')}</Link></h4>
                                                </div>

                                                {/* <Link to={_getAccountSettings.transaction_activity_status == 2 ? URLS.SALES_GL_CLASSIFICATION_STATUS : 'javascript:void(0)'} className='steps-panel-a'>
                                                    <span>5</span>
                                                    <h4>Revenue Classification</h4>
                                                </Link> */}

                                            </li>

                                            {/* <li className="step-block completed">
                                            <div>
                                                <span>2</span>
                                                <h4>Expense GL Classification</h4>
                                            </div>
                                        </li> */}

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        [1, 3].includes(_getAccountSettings.accounting_type) ? (
                            <div className="dashboard-wrap">
                                <div className="row mb-3">
                                    <div className="col-sm-12">
                                        <strong>
                                            {t('dashboard.welcome.message')}
                                        </strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="dashboard-box">
                                            <div className="accordion" id="manualGLIntegration">
                                                <div className="accordion-item bg-white">
                                                    <h2 className="accordion-header" id="manualGlConfiguation">
                                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                                            <img src={'third-party-coonect.svg'} alt="" /> {t('dashboard.manual.message')}
                                                        </button>
                                                    </h2>
                                                    <div id="collapseSix" className="collapse show" aria-labelledby="manualGlConfiguation" data-bs-parent="#manualGLIntegration">
                                                        <div className="accordion-body">
                                                            <ul className="steps-panel">
                                                                <li className={`border-0 step-block ${!!_getAccountSettings.is_coa_modified ? 'completed' : 'active'}`}>
                                                                    <div className='step-block-inner'>
                                                                        <span><Link to={URLS.CHARTACCOUNT} className='text-dark steps-panel-a p-0'>1</Link></span>
                                                                        <h4><Link to={URLS.CHARTACCOUNT} className='text-dark steps-panel-a p-0'>{t('dashboard.step_1.title')}</Link></h4>
                                                                    </div>
                                                                </li>
                                                                <li className={`border-0 step-block ${!!_getAccountSettings.is_beginning_balance_exists ? 'completed' : 'active'}`}>
                                                                    <div className='step-block-inner'>
                                                                        <span><Link to={(_getAccountSettings.is_coa_modified == 1 && _getThirdPartyStepsCompleted == 0) ? URLS.OPENNING_BALANCE : URLS.THIRD_PARTY} className='steps-panel-a text-dark p-0'>2</Link></span>
                                                                        <h4><Link to={(_getAccountSettings.is_coa_modified == 1 && _getThirdPartyStepsCompleted == 0) ? URLS.OPENNING_BALANCE : URLS.THIRD_PARTY} className='steps-panel-a text-dark p-0'>{t('dashboard.step_2.title')}</Link></h4>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="steps-panel-wrapper">
                                        <ul className="steps-panel">
                                            <li className={`step-block ${!!_getAccountSettings.is_coa_modified ? 'completed' : 'active'}`}>
                                                <div className='step-block-inner'>
                                                    <span><Link to={URLS.CHARTACCOUNT} className='steps-panel-a'>1</Link></span>
                                                    <h4><Link to={URLS.CHARTACCOUNT} className='steps-panel-a'>Enter COA</Link></h4>
                                                </div>
                                            </li>
                                            <li className={`step-block ${!!_getAccountSettings.is_beginning_balance_exists ? 'completed' : 'active'}`}>
                                                <div className='step-block-inner'>
                                                    <span><Link to={(_getAccountSettings.is_coa_modified == 1 && _getThirdPartyStepsCompleted == 0) ? URLS.OPENNING_BALANCE : URLS.THIRD_PARTY} className='steps-panel-a'>2</Link></span>
                                                    <h4><Link to={(_getAccountSettings.is_coa_modified == 1 && _getThirdPartyStepsCompleted == 0) ? URLS.OPENNING_BALANCE : URLS.THIRD_PARTY} className='steps-panel-a'>Enter Begining Balance</Link></h4>
                                                </div>
                                            </li>
                                        </ul>
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        ) : <></>
                    )
                }

                {
                    [2, 3].includes(_getAccountSettings.accounting_type) ? (
                        <div className="dashboard-wrap mt-3">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="dashboard-box">
                                        <div className="accordion" id="thirdPartyIntegration">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="thirdPartyIntegrationOne">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                                        <img src={'third-party-coonect.svg'} alt="" /> {t('dashboard.third_party_integration.title')}
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" className="collapse show" aria-labelledby="thirdPartyIntegrationOne" data-bs-parent="#thirdPartyIntegration">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            <li>
                                                                {
                                                                    (/*_getAccountSettings.is_beginning_balance_exists == 1 &&*/ _getAccountSettings.is_coa_modified == 1 && !_getThirdPartyStepsCompleted) ? (
                                                                        <Link to={'javascript:void(0)'}>{t('dashboard.third_party_integration.not_available')}</Link>
                                                                    ) : (
                                                                        <Link to={URLS.THIRD_PARTY}>{t('dashboard.third_party_integration.available')}</Link>
                                                                    )
                                                                }
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : <></>
                }

                {
                    (_getAccountSettings.transaction_activity_status >= 3 || _getThirdPartyStepsCompleted >= 3) ? (
                        <div className="dashboard-wrap mt-3">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="dashboard-box">
                                        <div className="accordion" id="gustoIntegration">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="gustoIntegrationOne">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="true" aria-controls="collapseSeven">
                                                        <img src={'third-party-coonect.svg'} alt="" /> Payroll Integration
                                                    </button>
                                                </h2>
                                                <div id="collapseSeven" className="collapse show" aria-labelledby="gustoIntegrationOne" data-bs-parent="#gustoIntegration">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            <li>
                                                                <Link to={URLS.GUSTO_CONNECTION}>Gusto Integration</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (<></>)
                }


            </div>

            {
                (modalSyncGl['syncBankAcc'] || modalSyncGl['syncSalesAcc']) &&
                <RevrexSyncGLAcc syncBankAcc={modalSyncGl['syncBankAcc']} syncSalesAcc={modalSyncGl['syncSalesAcc']} _handleCloseModal={closeSyncModal} /> || <></>
            }

            {
                showCOAModal && <ChartAccountModal closeModal={hideCOAModal} addRecord={createNewAccount} record={null} /> || <></>
            }

            {/* <SAlert
                msg={t('dashboard.upgrade.confirmation')}
                show={confirmationToLatest}
                title={t('dashboard.upgrade.confirmation.info')}
                confirmBtnText={t('dashboard.upgrade.confirmation.btn_confirm')}
                cancelBtnText={t('dashboard.upgrade.confirmation.btn_cancel')}
                onConfirm={confirmUpdationToLatest}
                showCancel={true}
                onCancel={() => setConfirmationToLatest(false)}
            /> */}

            <SAlert
                msg={t('dashboard.third_party_integration.qbo_import_instructions')}
                show={showQBOAlert}
                title={t('dashboard.third_party_integration.qbo_import_instructions_title')}
                confirmBtnText={t('dashboard.third_party_integration.qbo_import_instructions_btn')}
                onConfirm={() => {
                    setShowQBOAlert(false)
                    navigate(URLS.BANK_RECONCILE);
                }}
                showCancel={false}
                onCancel={() => setShowQBOAlert(false)}
            />

            <SAlert
                HtmlMsg={t('dashboard.pos_mismatch_closed_month_deposit_sales.message')}
                show={showPosMismatchClosedMonthDepositSalesAlert}
                title={t('dashboard.pos_mismatch_closed_month_deposit_sales.title')}
                confirmBtnText={t('dashboard.pos_mismatch_closed_month_deposit_sales.btn')}
                onConfirm={() => {
                    setShowPosMismatchClosedMonthDepositSalesAlert(false)
                    window.location.href = REVREX_APP_BASE_URL || "";
                }}
                showCancel={false}
                onCancel={() => setShowPosMismatchClosedMonthDepositSalesAlert(false)}
            />

        </div>
    )
}

export default Dashboard;